import React from 'react';
import './style.scss';

const Loading = () => {
  return (
    <div className="loader"></div>    
  );
}

export default Loading;